import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {HttpErrorResponse} from "@angular/common/http";
import {AlbtelecomOffer} from "../../../../../models/SearchService/albtelecom-offer.model";
import {AlbtelecomHttpClientService} from "../../../../../data/albtelecom-http-client.service";
import {toastrService} from "../../../../../services/ux/toastr.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: "app-albtelecom-list-of-offers",
    templateUrl: "./albtelecom-list-of-offers.component.html",
    styleUrls: ["./albtelecom-list-of-offers.component.css"]
})
export class AlbtelecomListOfOffersComponent implements OnInit {

    @Input() mobileNumber: string;
    @Output() switchScreenEmitter = new EventEmitter<number>();


    offers = [];

    showedOffers: AlbtelecomOffer[] | null;

    constructor(
      private albtelecomHttpClient: AlbtelecomHttpClientService,
      private toastr: toastrService,
      private translateService: TranslateService
    ) { }

    // region pagination
    numberOfDots = [];

    currentIndex = 0;

    // endregion


    ngOnInit() {
        this.getOffers();
    }

    activateOffer(offer: AlbtelecomOffer) {
        this.albtelecomHttpClient.activateOffer(this.mobileNumber, offer).subscribe(
            {
                next: () => {
                    this.toastr.success(this.translateService.instant("Services.OfferActivated"));

                    // * Reload page to albtelecom path when toastr timer ends
                    setTimeout(() => {
                        window.location.pathname = "/services/albtelecom";
                    }, 3500);
                },
                error: (err: HttpErrorResponse) => {
                    this.toastr.warning(this.translateService.instant("Services.BidActivationFailed"));
                }
            }
        );
    }

    getOffers() {
        this.albtelecomHttpClient
            .searchOffers("0684223843")
            .subscribe(
                {
                    next: offers => {
                        this.numberOfDots = Array(this.calculateDots(offers.length));
                        this.arrange(offers);
                    },
                    error: () => {
                        this.toastr.warning(this.translateService.instant("Services.ReceivingBidProblem"));
                    }
                }
            );
    }

    calculateDots(numberOfOffers: number): number {
        return Math.ceil(numberOfOffers / 8);
    }

    arrange(offers: any[]) {
        for (let i = 0; i < this.numberOfDots.length; i++) {
            this.offers.push(offers.splice(0, 8));
        }

        this.showedOffers = this.offers[0];
    }

    switchPage(index: number) {

        if (this.currentIndex === index) {
            return;
        }

        this.currentIndex = index;
        this.showedOffers = this.offers[index];
    }

    previousPage() {
        if (this.currentIndex === 0) {
            return;
        }
        this.currentIndex -= 1;
        this.showedOffers = this.offers[this.currentIndex];
    }

    nextPage() {
        if (this.currentIndex === this.numberOfDots.length - 1) {
            return;
        }
        this.currentIndex += 1;
        this.showedOffers = this.offers[this.currentIndex];
    }

    onBack() {
        this.switchScreenEmitter.emit(1);
    }
}
